export const getDataUrl = (svg: string) =>
    `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

export const recommendedRibbon = `
<svg width="364" height="42" viewBox="0 0 364 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="-4.57129" y="-79.8093" width="314.092" height="99" transform="rotate(1.68176 -4.57129 -79.8093)"
          fill="#1868DB" />
    <rect x="58" y="-68" width="316" height="99" fill="#BF63F3" />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M309.31 -67.9375L306.482 28.3684L58 21.0728L58 -67.9375L309.31 -67.9375Z" fill="#09326C" />
</svg>
`;

export const eyelash = `<svg
        width="158"
        height="60"
        viewBox="0 0 158 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M148.165 24.7368C148.443 24.9032 152.872 23.7464 151.577 23.1746C151.137 22.9052 150.742 22.9702 150.631 23.4336C150.458 22.5678 149.666 23.8063 149.245 23.5539C149.36 22.9305 148.201 24.3065 148.405 23.6509C143.545 23.3878 134.118 30.1216 145.797 25.5776C144.606 25.4 145.705 25.0663 146.241 25.1579C145.521 26.0025 147.7 25.1417 148.095 24.838C147.411 24.9098 148.513 24.2398 148.163 24.7349L148.165 24.7368Z"
                fill="#FCA700"
            />
            <path
                d="M139.09 18.0437C139.717 17.9536 142.159 13.4402 142.472 13.004C142.972 11.9531 141.52 11.9915 141.323 12.8686C141.212 13.0249 140.857 14.2799 140.54 13.7806C139.32 14.151 139.247 16.3481 138.213 16.5686C138.393 16.8425 138.04 17.2155 138.133 17.4009C137.822 17.3929 137.668 17.8224 137.744 17.8536C136.472 19.0375 138.168 20.1745 138.808 18.5707C138.864 18.6325 139.211 18.3305 139.09 18.0478L139.09 18.0437Z"
                fill="#FCA700"
            />
            <path
                d="M122.699 11.2861C122.166 12.0451 122.172 11.2894 122.435 10.9215C122.972 11.5193 122.905 10.0266 122.717 9.65787C122.693 9.81547 122.426 9.86195 122.457 9.53569C123.114 9.78146 123.467 5.65475 121.974 7.56402C121.973 7.63466 122.499 7.6814 122.33 7.75934C121.539 7.59711 122.062 8.26246 122.113 8.44715C121.698 8.43086 122.075 8.61625 121.9 8.6573C121.354 8.41717 122.232 9.49993 121.693 9.23018C120.794 10.1515 121.815 12.0569 121.004 12.7574C121.91 13.2838 120.354 16.2711 122.199 15.155C122.672 13.8614 122.956 12.7989 122.699 11.2861Z"
                fill="#FCA700"
            />
            <path
                d="M132.652 3.70288C131.388 3.33811 131.516 6.18933 130.949 6.94681C130.15 7.86012 127.016 17.8328 129.676 15.2959C130.6 12.2706 131.877 9.93251 132.54 6.13971C132.692 5.52981 133.552 3.64674 132.652 3.70288Z"
                fill="#FCA700"
            />
            <path
                d="M142.401 34.3268C141.613 35.3616 140.626 34.024 139.884 34.8725C138.748 36.5081 148.206 37.3044 147.988 35.5914C147.602 34.1514 143.045 34.9678 142.401 34.3268Z"
                fill="#FCA700"
            />
        </svg>`;
